export default "__VITE_ASSET__CdxaoNGF__ 78w";